import './styles/theme.css';
import './styles/landing.css';
import './styles/auth.css';
import './styles/app.css';

import { startRouter, onRoute, parseHash, navigate } from './utils/router.js';
import { initTheme } from './utils/theme.js';
import { getToken, getApiBase } from './api.js';
import { registerServiceWorker, captureInstallPrompt, isStandalone } from './utils/pwa.js';
import { renderLanding } from './modules/landing.js';
import { renderLogin, renderRegister } from './modules/auth.js';
import { renderApp } from './modules/app.js';

const appRoot = document.getElementById('app');
let cleanup = null;

initTheme();
captureInstallPrompt();
registerServiceWorker();

// If already standalone, theme-color is fine
if (isStandalone()) {
  document.documentElement.classList.add('standalone');
}

const PUBLIC = new Set(['', '/', 'landing', 'login', 'register']);

function isPublicPath(segments) {
  const first = segments[0] || '';
  return PUBLIC.has(first) || first === '';
}

async function handleRoute(route) {
  if (typeof cleanup === 'function') {
    try {
      cleanup();
    } catch {
      /* ignore */
    }
    cleanup = null;
  }

  // scroll to top on route change (except landing internal)
  window.scrollTo(0, 0);

  const segs = route.segments;
  const first = segs[0] || '';

  // Auth gate for app routes
  const needsAuth = !isPublicPath(segs);
  if (needsAuth && !getToken()) {
    navigate('/login', { replace: true });
    return;
  }

  // Logged-in users hitting landing → app
  if ((first === '' || first === 'landing') && getToken() && route.query.force !== '1') {
    // still allow viewing landing once via #/?force=1
    // default: show landing first time; only skip if already seen this session? 
    // Spec: entry is landing storytelling. Keep landing public.
  }

  if (!first || first === 'landing') {
    cleanup = renderLanding(appRoot) || null;
    return;
  }
  if (first === 'login') {
    if (getToken()) {
      navigate('/app', { replace: true });
      return;
    }
    cleanup = renderLogin(appRoot) || null;
    return;
  }
  if (first === 'register') {
    if (getToken()) {
      navigate('/app', { replace: true });
      return;
    }
    cleanup = renderRegister(appRoot) || null;
    return;
  }

  // Everything else → app shell
  cleanup = (await renderApp(appRoot, route)) || null;
}

onRoute(handleRoute);
startRouter();

// Expose for debugging / deploy overrides
window.__GSORG__ = {
  navigate,
  parseHash,
  getApiBase,
};
